import { combineReducers, createStore } from 'redux'

import apiResponseReducers from './store/reducers/apiResponseReducers'
import appReducer from './store/reducers/appReducer'
import userReducer from './store/reducers/userReducer'
import vaultReducer from './store/reducers/vaultReducer'
import salesReducer from './store/reducers/salesReducer'
import businessReducer from './store/reducers/businessListingReducer'
import alertTabReducer from './store/reducers/alertTabReducer';
import commonReducer from 'store/reducers/commonReducer';
import authReducer from 'store/reducers/authReducer';
import correctYourDataReducer from 'store/reducers/correctYourDataReducer';

const rootReducer = combineReducers({
  appReducer,
  apiResponseReducers,
  userReducer,
  vaultReducer,
  salesReducer,
  businessReducer,
  alertTabReducer,
  commonReducer,
  authReducer,
  correctYourDataReducer
})

export const store = createStore(rootReducer)
